
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const ShopPage = lazy(() => import('../pages/shop/page'));
const ProductDetailPage = lazy(() => import('../pages/product/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const DealersPage = lazy(() => import('../pages/dealers/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/shop',
    element: <ShopPage />
  },
  {
    path: '/products',
    element: <ProductsPage />
  },
  {
    path: '/product/:id',
    element: <ProductDetailPage />
  },
  {
    path: '/about',
    element: <AboutPage />
  },
  {
    path: '/dealers',
    element: <DealersPage />
  },
  {
    path: '/faq',
    element: <FAQPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
